<template>
	<b-form @submit.stop.prevent="save($event); return false">
		<b-form-row>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<b-form-row class="mb-3">
						<b-col>
							<b-form-checkbox switch inline v-model="settings.enable" class="mb-2">Display alerts</b-form-checkbox>
							<b-form-group label="Alert minimum amount">
								<b-input-group :append="user?.currency_code">
									<b-form-input type="number" min="0" v-model="settings.minDonation" :disabled="!settings.enable"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-checkbox switch inline v-model="settings.enableTTS" class="mb-2">Enable text-to-speech</b-form-checkbox>
							<b-form-group label="TTS minimum amount">
								<b-input-group :append="user?.currency_code">
									<b-form-input type="number" min="0" v-model="settings.ttsMinDonation" :disabled="!settings.enableTTS"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-checkbox switch inline v-model="settings.enableMedia" class="mb-2">Enable media playback</b-form-checkbox>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Media minimum amount">
								<b-input-group :append="user?.currency_code">
									<b-form-input type="number" min="0" v-model="settings.mediaMinDonation" :disabled="!settings.enableMedia"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Media time limit">
								<b-input-group append="minutes">
									<b-input v-model="settings.mediaTimeLimit"></b-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Minimum like-to-dislike ratio" class="mb-3">
								<b-input-group append="%">
									<b-input v-model.number="settings.mediaMinRatio" type="number" min="0" max="100"></b-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Media minimum views">
								<b-form-input type="number" min="0" v-model="settings.mediaMinViews" :disabled="!settings.enableMedia"></b-form-input>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
					</b-form-row>
				</b-card>
				<b-card class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="In Transition">
								<b-form-select v-model="settings.inTransition" :options="inTransitions"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Out Transition">
								<b-form-select v-model="settings.outTransition" :options="outTransitions"></b-form-select>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Animation duration" append="ms">
								<b-input-group append="ms">
									<b-form-input type="number" min="0" max="5000" v-model="settings.duration"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Linger duration">
								<b-input-group append="ms">
									<b-form-input type="number" min="0" max="60000" v-model="settings.linger"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Load timeout">
								<b-input-group append="ms">
									<b-form-input type="number" min="0" max="100000" step="1" v-model="settings.loadTimeout"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<text-settings :settings="settings" />
				<b-card class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="Text Color">
								<color-picker v-model="settings.textColor" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Gift Background">
								<color-picker v-model="settings.textBg" />
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Text outline blur" append="px">
								<b-input-group append="px">
									<b-form-input type="number" min="0" max="100" step="any" v-model="settings.blurRadius"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Text outline size" append="px">
								<b-input-group append="px">
									<b-form-input type="number" min="0" max="10" step="any" v-model="settings.spreadRadius"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Outline Color">
								<color-picker v-model="settings.shadowColor" />
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Width" append="px">
								<b-input-group append="px">
									<b-form-input type="number" min="0" step="any" v-model="settings.width"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Top margin" append="px">
								<b-input-group append="px">
									<b-form-input type="number" min="0" step="any" v-model="settings.marginTop"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Image height" append="px">
								<b-input-group append="px">
									<b-form-input type="number" min="0" step="any" v-model="settings.imageHeight"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>

				<b-card class="mb-3">
					<b-form-group label="Platforms:" label-cols="4">
						<div class="col-form-label text-right">
							<b-form-group>
								<b-form-radio-group :options="serviceOptions" v-model="settings.serviceMode" name="serviceMode" />
							</b-form-group>
						</div>
					</b-form-group>
					<b-form-checkbox-group v-model="settings.services" :options="services" value-field="id" text-field="name" />
				</b-card>

				<b-card class="mb-3">
					<b-form-group label="Extra CSS">
						<b-textarea v-model="settings.extraCSS"></b-textarea>
					</b-form-group>
				</b-card>
			</b-col>
			<b-col cols="12" lg="6">
				<preview class="mb-3" slug="gift" name="Alert" />
			</b-col>
		</b-form-row>
		<b-card class="text-center mb-3">
			<b-alert variant="danger" :show="!!saveError">{{saveError}}</b-alert>
			<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
				<b-button variant="primary" type="submit">Save settings</b-button>
			</b-overlay>
		</b-card>
	</b-form>
</template>

<script>
import animateCssTransitions from '@/animateCssTransitions';
import ColorPicker from '@/components/ColorPicker.vue';
import Preview from '@/components/Widget/Preview.vue';
import TextSettings from '@/components/Widget/TextSettings.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		settings: null,
		inTransitions: [ ...[{ text: 'Don\'t fade in', value: null }], ...animateCssTransitions.inTransitions ],
		outTransitions: [ ...[{ text: 'Don\'t fade out', value: null }], ...animateCssTransitions.outTransitions ],
		curColor: null,
		giftEventTypes: null,
		user: null,
		services: [],
		serviceOptions: [ { text: 'Exclude', value: '' }, { text: 'Only selected', value: 'selected' } ],
	}; },
	components: {
		ColorPicker,
		Preview,
		TextSettings,
	},
	async mounted() {
		try {
			this.loading++;
			this.error = null;
			this.saveError = null;
			this.settings = null;
			const settings = await this.$api.get('widgetSettings/gift');
			this.settings = {
				...settings,
				enableTTS: settings.enableTTS||false,
				enableEventSounds: settings.enableEventSounds||false,
				inTransition: settings.inTransition||null,
				outTransition: settings.outTransition||null,
				textColor: settings.textColor || 'rgba(255, 255, 255, 1)',
				shadowColor: settings.shadowColor || 'rgba(0, 0, 0, 1)',
				spreadRadius: settings.spreadRadius || 0,
				blurRadius: settings.blurRadius || 0,
				textBg: settings.textBg || 'rgba(0, 128, 0, 1)',
				widgetBg: settings.widgetBg || 'rgba(0, 0, 0, 0)',
				fontFamily: settings.fontFamily || '',
				fontSize: settings.fontSize || 0,
				lineHeight: settings.lineHeight || 0,
				letterSpacing: settings.letterSpacing || 0,
				width: settings.width || 0,
				marginTop: settings.marginTop || 0,
				textAlign: settings.textAlign || 'left',
				boldText: settings.boldText || false,
				italicText: settings.italicText || false,
				underlineText: settings.underlineText || false,
				strikethroughText: settings.strikethroughText || false,
				uppercaseText: settings.uppercaseText || false,
				extraCSS: settings.extraCSS || '',
				customFont: settings.customFont || false,
				serviceMode: settings.serviceMode || '',
				minDonation: settings.minDonation || 0,
				ttsMinDonation: settings.ttsMinDonation || 0,
			};
			await this.loadGiftEventTypes();
			this.services = (await this.$api.get('services')).filter(c => c.capabilities.indexOf('chat') !== -1);
			this.user = await this.$api.get('userData');
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async loadGiftEventTypes() {
			this.giftEventTypes = null;
			this.giftEventTypes = await Promise.all([
				this.$api.get('userEventType/gift'),
				this.$api.get('userEventType/subGift'),
				this.$api.get('userEventType/subscription'),
				this.$api.get('userEventType/subExtend'),
			]);
		},
		async save() {
			try {
				this.saving++;
				this.error = null;

				await this.$api.post('widgetSettings/gift', {
					...this.settings,
				});
			} catch(err) {
				console.error('Error saving widget:', err);
				this.saveError = err;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
